import { render, staticRenderFns } from "./items-details.vue?vue&type=template&id=16f238a4&scoped=true&"
import script from "./items-details.vue?vue&type=script&lang=js&"
export * from "./items-details.vue?vue&type=script&lang=js&"
import style0 from "./items-details.vue?vue&type=style&index=0&id=16f238a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f238a4",
  null
  
)

export default component.exports